import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import {COMMON_DIALOG_IMPORTS} from "../../shared/import-groups/Common";
import {MatButton} from "@angular/material/button";

export interface ConfirmDialogData {
    message: string;
    cancelText?: string;
    okText?: string;
}

/**NOTES
 * Can be accessed via the FormDialogService using e.g.:
 *  async editOrSave() {
        const continue_edit = await this.formDialogService.confirm('You are editing the data of the previous ' + this.name +
            ' entry. Please click "Clear" if you would like to register a new ' + this.name + '. Continue?', 'No', 'Yes');

        if (continue_edit) {
            this.save();
        }
    }
 */
@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.less'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatDialogTitle,
        MatDialogActions,
        MatButton,
        MatDialogContent
    ]
})
export class ConfirmDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
    ) {
        this.data.cancelText = this.data.cancelText || 'Cancel';
        this.data.okText = this.data.okText || 'OK';
    }

    onSubmit(event: Event): void {
        event.preventDefault();
        this.dialogRef.close(true);
    }
}
